import { useIsOwner, usePermissionsChecker } from '@btime/react-session'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { formatPlaceTypePermission, usePlaceTypes } from '../../../utils/helpers/placeTypes'
import { useOpenEditPermissionsModal, useOpenEditPlaceTypesModal } from '../../../utils/routes/modals/modalsActions'
import List from '../../../components/list/List'
import MenuItem from './_shared/MenuItem'
import SubMenuItem from './_shared/SubMenuItem'

const PlacesMenuItem = () => {
  const { t } = useTranslation('menu')
  const [placeTypes] = usePlaceTypes()
  const isOwner = useIsOwner()
  const checkPermission = usePermissionsChecker()
  const openPermissionsModal = useOpenEditPermissionsModal()
  const openEditPlaceTypeModal = useOpenEditPlaceTypesModal()
  const allPermissions = [
    'listChecklist',
    'listUser',
    'listAsset',
    'listSegment',
    'setupServiceOrder',
    ...placeTypes?.map(type => `list${formatPlaceTypePermission(type.key)}`)
  ]

  if (!isOwner && !checkPermission(allPermissions)) return false

  return (
    <MenuItem
      icon="RiSettings3Line"
      label={t('settings')}
      top="auto"
      bottom="-7rem"
      noTooltipPadding
      tooltip={
        <List minWidth="14rem" minHeight="8.5rem">
          <SubMenuItem
            icon="RiListSettingsLine"
            label={t('generalRegistrations')}
            path="/minicruds/pending"
            permission="setupServiceOrder"
          />
          <SubMenuItem icon="RiListCheck2" label={t('checklists')} path="/checklists" permission="listChecklist" />
          <SubMenuItem icon="RiHashtag" label={t('masks')} path="/masks" permission="listMasks" />

          <SubMenuItem icon="RiAccountBoxLine" label={t('users')} path="/users" permission="listUser" />
          {placeTypes?.map(type => (
            <SubMenuItem
              key={type.key}
              icon={type.icon}
              label={type.namePlural}
              path={`/places/${type.key}`}
              permission={`list${formatPlaceTypePermission(type.key)}`}
            />
          ))}

          <SubMenuItem icon="RiToolsFill" label={t('assets')} permission="listAsset" path="/assets" />
          <SubMenuItem icon="RiMindMap" label={t('segmentation')} path="/segmentations" permission="listSegment" />
          <SubMenuItem icon="RiLinksFill" label={t('integrations')} permission="listIntegration" path="/integrations" />
          <SubMenuItem icon="RiOutlet2Fill" label={t('webhook')} permission="listIntegration" path="/webhooks" />
          <SubMenuItem
            icon="RiToggleLine"
            label={t('modulesAndPermissions')}
            onClick={openPermissionsModal}
            hide={!isOwner}
          />

          <SubMenuItem
            icon="RiPlayListAddFill"
            label={t('createPlaceType')}
            color="primary"
            onClick={() => openEditPlaceTypeModal()}
            hide={!isOwner}
          />
        </List>
      }
    />
  )
}

export default PlacesMenuItem
